// ref: https://github.com/ktsn/vue-inversify-decorator/blob/master/src/index.ts
// 只修改了函数名和vue-property-decorator冲突
import 'reflect-metadata';
import { inject, ref } from 'vue';
import { createDecorator } from 'vue-class-component';
export const containerKey = '__inversify_container__';
export const ProvideInversify = (container) => createDecorator(options => {
    options.mixins = options.mixins || [];
    options.mixins.push({
        provide: {
            [containerKey]: container,
        },
    });
});
export const InjectInversify = (identifier) => (proto, key) => {
    let Type;
    if (typeof Reflect !== 'undefined' && typeof Reflect.getMetadata === 'function') {
        Type = Reflect.getMetadata('design:type', proto, key);
    }
    return createDecorator((options, key) => {
        if (!options.__container_injected__) {
            options.mixins = options.mixins || [];
            options.mixins.push({
                inject: [containerKey],
            });
            options.__container_injected__ = true;
        }
        options.computed = options.computed || {};
        options.computed[key] = function () {
            return this[containerKey].get(identifier || Type);
        };
    })(proto, key);
};
export const InjectInversifyReactive = (identifier) => (proto, key) => {
    let Type;
    if (typeof Reflect !== 'undefined' && typeof Reflect.getMetadata === 'function') {
        Type = Reflect.getMetadata('design:type', proto, key);
    }
    return createDecorator((options, key) => {
        if (!options.__container_injected__) {
            options.mixins = options.mixins || [];
            options.mixins.push({
                inject: [containerKey],
            });
            options.__container_injected__ = true;
        }
        options.mixins.push({
            data() {
                return {
                    [key]: this[containerKey].get(identifier || Type),
                };
            },
        });
    })(proto, key);
};
export const InjectInversify2 = (identifier) => {
    const container = inject(containerKey);
    if (!container) {
        console.error('Container not found. Make sure to use @ProvideInversify decorator in parent component.');
    }
    return container.get(identifier);
};
export const InjectInversifyReactive2 = (identifier) => {
    const container = inject(containerKey);
    const service = ref(null);
    if (!container) {
        console.error('Container not found. Make sure to use @ProvideInversify decorator in parent component.');
    }
    else {
        service.value = container.get(identifier);
    }
    return service.value;
};
